import { render } from "./StoryCard.vue?vue&type=template&id=5d12a5a8&scoped=true"
import script from "./StoryCard.vue?vue&type=script&lang=js"
export * from "./StoryCard.vue?vue&type=script&lang=js"

import "./StoryCard.vue?vue&type=style&index=0&id=5d12a5a8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d12a5a8"]])

export default __exports__